import axios from "axios";
import {
  APPLICATION_LOCAL_STORAGE,
  AUTH_TOKEN_GENERATION_TIME_IN_SEC,
  FLOATING_WIDGET_PATH_URL,
  REDIRECTION_PAGE,
  ROUTES_NAME,
  STATUS_CODE,
} from "./common/constants/constants";
import { getEnv } from "./enviroment";
const { base } = getEnv();
const pathname = "/chatbot/floatingwidget"
const generateAuthTokenByRefreshToken = async () => {
  try {
    let storedrefreshToken = localStorage.getItem(
      APPLICATION_LOCAL_STORAGE.REFRESH_TOKEN
    );
    if (storedrefreshToken != null) {
      // Check Timestamp for refreshToken
      let loginTimestamp = localStorage.getItem(
        APPLICATION_LOCAL_STORAGE.TOKEN_TIME_STAMP
      );
      let sessionTimeoutInMilliseconds = localStorage.getItem(
        APPLICATION_LOCAL_STORAGE.SESSION_TIMEOUT_IN_MILLI_SECONDS
      );

      let capTime = sessionTimeoutInMilliseconds - 120000; //Substract 2 min which came from backend Timeout saved in milliseconds
      let buffTime = parseInt(loginTimestamp) + capTime; // Login Time + CapTime
      let currentTimestamp = Date.now();
      if (currentTimestamp >= buffTime) {
        const payload = {
          refreshToken: storedrefreshToken,
        };

        const res = await axios.post(`${base}/generate/authToken`, payload);

        if (res?.status == STATUS_CODE.OK) {
          localStorage.setItem(
            APPLICATION_LOCAL_STORAGE.AUTH_TOKEN,
            res?.data?.authToken
          );
          // Update login TimeStamp to check Authentication for refreshtoken
          const currentTimeStamp = Date.now();
          localStorage.setItem(
            APPLICATION_LOCAL_STORAGE.TOKEN_TIME_STAMP,
            currentTimeStamp
          );

          var localTimeStr = new Date(currentTimeStamp).toLocaleTimeString(
            "en-US"
          );
          localStorage.setItem(
            APPLICATION_LOCAL_STORAGE.REFRESH_TOKEN_LAST_UPDATED_AT,
            localTimeStr
          );
        } else {
          redirect();
        }
      }
    }
  } catch (err) {
    redirect();
  }
};

setInterval(generateAuthTokenByRefreshToken, AUTH_TOKEN_GENERATION_TIME_IN_SEC);

const redirect = async () => {
  localStorage.clear();
  if (window.location.pathname === pathname) {
    window.location.replace(REDIRECTION_PAGE.FLOATING_WIDGET_ERROR_PAGE);
    console.log("Redirect to Error page for Floating Widget.");
  }
  else if (window?.location?.pathname === ROUTES_NAME?.DOORDASH_POC) {
    localStorage.setItem(APPLICATION_LOCAL_STORAGE?.SESSION_TIMEOUT, true);
    window.parent.location.replace(REDIRECTION_PAGE.LOGIN_PAGE);
  }
  else {
    window.location.replace(REDIRECTION_PAGE.LOGIN_PAGE);
    console.log("Redirect to Login page for Web.");
  }

};
